import moment from "moment";

export default {
  showSubscriberModal(state) {
    return state.showSubscriberModal;
  },
  getSubscribersList(state) {
    let items = state.subscribersList;
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        item.created = moment(item.created).format("lll");
      }
    }
    return items;
  },
  getSubscribersListItem(state) {
    return state.subscribersListItem;
  },
  getSubscribers(state) {
    return state.subscribers;
  },
  getSubScriberItem(state) {
    return state.subScriberItem;
  },
  getGuestItem(state) {
    return state.guestItem;
  },
  getAddDialogVisible(state) {
    return state.addDialogVisible;
  },
  getUpdateDialogVisible(state) {
    return state.updateDialogVisible;
  },
  getSubcriberProfile(state) {
    return state.subscriberProfile;
  },
  getSubcriberCards(state) {
    let items = state.subscriberProfile;
    let cards = [];
    if (items && items.cards > 0) {
      for (let i = 0; i < items.cards; i++) {
        let item = items[i];
        cards.push(item);
        console.log(item);
      }
    }
    return cards;
  },
  getLocationIds(state) {
    return state.locationIds;
  },
  getLocationGroupIds(state) {
    return state.locationGroupIds;
  },
  getGuests(state) {
    return state.guests;
  },
  getGuestPage(state) {
    return state.guestPage;
  },
  getSubscriberPage(state) {
    return state.subscriberPage;
  },
  getSubscriberPageS3(state) {
    return state.subscriberPageS3;
  },
  getGuestPageS3(state) {
    return state.guestPageS3;
  },
};
